import { useRouter } from "next/router";
import QS from "query-string";

function useSafeRouter() {
  const router = useRouter();
  let query;
  if (process.browser) {
    query = { ...QS.parse(location.search), pathname: router.query.pathname };
  } else {
    query = router.query;
  }
  return {
    ...router,
    query,
  };
}

export default useSafeRouter;
